import React from 'react';
const Footer = () => {
  return (
    <div className="bg-white dark:bg-transparent h-[60px] mt-5 border-t dark:border-none  text-center flex items-center text-[#98A6AD] dark:text-[#A6AFB8] justify-center px-6 text-sm ">
      2023 © Ryzeo
    </div>
  );
};
export default Footer;
